import React from 'react'
import {
  PixelCurrency,
  PixelDiv,
  PixelFlexBox,
  PixelText,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

const OrderHistries = (props) => {
  const { customer } = props
  const [latestInvoice, setLatestInvoice] = React.useState<any>({})

  const [latestPayment, setLatestPayment] = React.useState<any>({})

  React.useEffect(() => {
    if (customer?.transactions?.length > 0) {
      setLatestInvoice(getLatestInvoice())
      setLatestPayment(getLatestPayment())
    }
  }, [customer])

  const getLatestInvoice = () => {
    const latest = customer.invoices
      .sort(
        (a: any, b: any) =>
          new Date(a.date_created).getTime() -
          new Date(b.date_created).getTime(),
      )
      .reverse()
    return latest ? latest[0] : undefined
  }

  const getLatestPayment = () => {
    const latest = customer?.transactions
      .sort(
        (a: any, b: any) =>
          new Date(a?.created_at).getTime() - new Date(b?.created_at).getTime(),
      )
      .reverse()
    return latest ? latest[0] : undefined
  }

  return (
    <>
      <PixelFlexBox flexDirection="column">
        <PixelFlexBox>
          <SectionTitle>Customer Info</SectionTitle>
        </PixelFlexBox>
        <PixelFlexBox flexDirection="column" className="user-info">
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              CUSTOMER SINCE:
            </PixelText>
            <Detail>{customer?.created_at || '--'}</Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              LAST INVOICE DATE:
            </PixelText>
            <Detail>{latestInvoice?.date_created || '--'}</Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              LAST INVOICE AMOUNT:
            </PixelText>
            <Detail>
              <PixelCurrency value={latestInvoice?.total} currency={'USD'} />
            </Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              LAST PAYMENT DATE:
            </PixelText>
            <Detail>{latestPayment?.created_at || '--'}</Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              LAST PAYMENT AMOUNT:
            </PixelText>
            <Detail>
              <PixelCurrency value={latestPayment?.amount} currency={'USD'} />
            </Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              AVG DAYS TO PAY INVOICE:
            </PixelText>
            <Detail>{'--'}</Detail>
          </PixelDiv>
          <PixelDiv
            style={{
              display: 'table',
              tableLayout: 'fixed',
              width: '100%',
              borderSpacing: '0',
              borderCollapse: 'collapse',
            }}
          >
            <PixelText
              style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#8e959b',
                display: 'table-cell',
                verticalAlign: 'middle',
                // padding: '10px',
                // backgroundColor: '#e9ecef',
              }}
            >
              LAST STATEMENT DATE:
            </PixelText>
            <Detail>{'--'}</Detail>
          </PixelDiv>
        </PixelFlexBox>
      </PixelFlexBox>
    </>
  )
}

const Detail = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #8e959b;
  display: table-cell;
  vertical-align: middle;
  padding-left: 10px;
  width: 60%;
  /* background-color: #e9ecef78; */
`

export default OrderHistries
